import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './Loader.module.scss'

const Loader = ({ isLoading, customLoader, children, small }) => {
  return (
    <>
      {isLoading
        ? customLoader ?? (
            <div className={classNames(styles.loader, { [styles.small]: small })}></div>
          )
        : children}
    </>
  )
}

Loader.defaultProps = {
  isLoading: true
}

Loader.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  customLoader: PropTypes.node,
  children: PropTypes.node,
  small: PropTypes.bool
}

export default Loader
